module.exports = __webpack_public_path__ + "static/img_5076-115b28686e36036e0efe818f1dd03fb9.webp";